<template>
  <v-container fluid class="px-0 py-0 mx-0">
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <label for="fileInput">
            <v-card-media v-if="imageSrc">
              <img :src="imageSrc" style="width:100%;height:100%;max-height:400px;object-fit:cover;"
              />
              <input id="fileInput" type="file" accept="image/jpeg, image/png" v-on:change="uploadPhoto">
            </v-card-media>
            <v-card-media v-else>
              <img src="./../assets/camera_background.png" style="height:100%;max-height:400px;object-fit: contain"
              />
              <input id="fileInput" type="file" accept="image/jpeg, image/png" v-on:change="uploadPhoto">
            </v-card-media>
          </label>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-container fluid class="px-0 py-0 mx-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-tabs fixed-tabs centered grow v-model="model" slot="extension">
                  <v-tab>
                    <span class="capitalize font-600">Productos</span>
                  </v-tab>
                  <v-tab>
                    <span class="capitalize font-600">Informacion</span>
                  </v-tab>
                </v-tabs>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-container grid-list-xl fluid class="px-0 pb-0 mx-0">
            <v-layout row wrap>
              <v-flex xs12 class="pb-0 pt-0">
                <v-tabs-items v-model="model">
                  <v-tab-item>
                    <v-card flat>
                      <v-container>
                        <grid :products="products" :editMode="true"></grid>
                      </v-container>
                    </v-card>
                  </v-tab-item>
                  <v-tab-item>
                    <v-card flat>
                      <v-container fluid class="px-0 py-0 mx-0">
                        <v-layout row wrap>
                          <v-flex xs12>
                            <v-card flat>
                              <v-container>
                                <v-layout row wrap>
                                  <v-flex xs6>
                                    <p class="font-600">{{ $store.getters.getUser.organization }}</p>
                                    <p class="font-600">Persona de contacto:</p>
                                    <p>{{ $store.getters.getUser.username }}</p>
                                  </v-flex>
                                  <v-flex xs6>
                                    <p class="font-600">Direccion:</p>
                                    <p>{{ $store.getters.getUser.address }}</p>
                                  </v-flex>
                                </v-layout>
                              </v-container>
                            </v-card>
                          </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                          <v-flex xs12 class="px-0 py-0">
                            <v-card flat>
                              <gmap-map :center="marker.position" :zoom="17" map-type-id="terrain" style="width: auto; height: 300px;">
                                <gmap-marker :position="marker.position
                                " :clickable="true " :draggable="true " @click="center=marker.position "></gmap-marker>
                              </gmap-map>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import HTTP from '@/axios-config'
import Grid from '@/components/Grid'

export default {
  components: {
    Grid
  },
  name: 'Profile',
  data () {
    return {
      model: 0,
      products: [],
      user: {
        organization: '',
        username: '',
        address: ''
      },
      imageSrc: null,
      marker: {
        position: {
          lat: 10.0,
          lng: 10.0
        }
      }
    }
  },
  created () {
    if (this.$store.getters.getUser.picture) this.imageSrc = this.$store.getters.getUser.picture
    this.getProductsByOwner()
    var geocoder = new window.google.maps.Geocoder()
    geocoder.geocode({
      'address': this.$store.getters.getUser.address
    }, function (results) {
      this.marker.position.lat = results[0].geometry.location.lat()
      this.marker.position.lng = results[0].geometry.location.lng()
    }.bind(this))
  },
  mounted () {},
  methods: {
    getProductsByOwner () {
      HTTP.get('/product/getProductsByOwner/' + this.$store.getters.getUser._id)
        .then(function (response) {
          this.products = response.data.result
        }.bind(this))
        .catch(function (error) {
          console.log(error)
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    },
    uploadPhoto (e) {
      if (!e.target.files[0] && !e.dataTransfer.files[0]) {
        return
      }
      let files = e.target.files || e.dataTransfer.files
      let reader = new FileReader()
      reader.onload = (e) => {
        this.imageSrc = e.target.result
      }
      reader.readAsDataURL(files[0])
      let data = new FormData()
      data.append(this.$store.getters.getUser._id, files[0])
      HTTP.post('/user/setProfilePhoto/' + this.$store.getters.getUser._id, data, {
        headers: {
          'content-type': 'multipart/form-data',
          'Authorization': localStorage.getItem('token')
        }
      })
        .then(function (response) {
          this.imageSrc = response.data.result.picture
          this.$store.getters.getUser.picture = response.data.result.picture
          let user = JSON.parse(localStorage.getItem('user'))
          user.picture = response.data.result.picture
          localStorage.setItem('user', JSON.stringify(user))
        }.bind(this))
        .catch(function (error) {
          console.log(error)
          if (error.response) this.$bus.$emit('event-toast', error.response.data.message)
        }.bind(this))
    }
  }
}

</script>

<!-- Add "scoped " attribute to limit CSS to this component only -->
<style scoped>
  .font-600 {
    font-weight: 600 !important;
  }

  .capitalize {
    text-transform: capitalize !important;
  }

  input {
    display: none !important;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Profile.vue